<template>
  <v-container
    style="position:absolute;left:50%;transform:translateX(-50%);"
    class="d-flex flex-column justify-center align-center"
  >
    {{ values.schritt }} / {{ values.anzahlSchritte }}
    <h1>
      Angaben zu deiner Person
    </h1>
    <p class="pa-6">
      Um die Anfrage zu prüfen und diese bestätigen zu können, benötigen wir
      noch einige Angaben zu deiner Person.
    </p>
    <v-form
      v-model="formvalid"
      class="pt-8"
    >
      <v-stepper v-model="e1" class="back lighten-1">
        <v-stepper-header>
          <v-stepper-step
            :complete="e1 > 1"
            step="1"
          >
            Rechnungsadresse
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="e1 > 2"
            step="2"
          >
            Deine Anfrage
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form v-model="formvalid">
              <div class="title pb-4 primary--text">Rechnungsadresse</div>
              <p style="hyphens:manual !important;" class="pb-8">
                Bitte gib deinen vollständigen Namen sowie Anschrift und
                Kontaktinformationen an.
              </p>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    label="Firma (optional)"
                    v-model="value.firma"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0" cols="4" md="2">
                  <v-select
                    label="Anrede"
                    v-model="value.anrede"
                    :items="['Herr', 'Frau']"
                    :rules="[
                      this.$store.state.inputValidationRules.required,
                    ]"
                  />
                </v-col>
                <v-col class="py-0" cols="8" md="10">
                  <v-text-field
                    label="Vor- und Nachname"
                    v-model="value.name"
                    :rules="[
                      this.$store.state.inputValidationRules.required,
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    label="E-Mail Adresse"
                    v-model="value.mail"
                    :rules="[
                      this.$store.state.inputValidationRules.required,
                      this.$store.state.inputValidationRules.email,
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    label="Telefonnummer"
                    v-model="value.telefon"
                    :rules="[
                      this.$store.state.inputValidationRules.required,
                      this.$store.state.inputValidationRules.telefon,
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    label="Straße und Hausnummer"
                    v-model="value.strasse"
                    :rules="[
                      this.$store.state.inputValidationRules.required,
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4" class="py-0">
                  <v-text-field
                    type="number"
                    label="PLZ"
                    v-model="value.plz"
                    :rules="[
                      this.$store.state.inputValidationRules.required,
                    ]"
                  ></v-text-field>
                </v-col>
                <v-col cols="8" class="py-0">
                  <v-text-field
                    label="Ort"
                    v-model="value.ort"
                    :rules="[
                      this.$store.state.inputValidationRules.required,
                    ]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                v-if="this.$store.state.formRechnungsadresseUseNachricht"
              >
                <v-col cols="12" class="py-0">
                  <v-textarea auto-grow
                    label="Nachricht (optional)"
                    v-model="value.nachricht"
                  />
                </v-col>
              </v-row>
            </v-form>
            <v-col class="py-0" align="right">
              <v-btn
                class="ma-2"
                @click="
                  $emit('back');
                "
              >
                Zurück
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="e1 = 2"
                :disabled="!formvalid"
              >
                Weiter
              </v-btn>
            </v-col>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form v-model="formvalid2" class="pb-8">
              <div class="title pb-4 primary--text">Deine Anfrage</div>
              <div v-html="prop_gesamtuebersicht"></div>
              <v-checkbox class="my-6"
                v-model="value.newsletter"
                label="Ich möchte zukünftig Sonderangebote / Last Minute Angebote erhalten."
              />
              <div class="my-6">
                <p>
                  Abschließend würden wir uns freuen, wenn du uns mitteilen könntest, wie du auf uns aufmerksam geworden bist. Deine Rückmeldung ist für uns äußerst hilfreich. Vielen herzlichen Dank!
                </p>
                <v-select
                  label="Woher kennst du uns?"
                  :items="[ 'Google-Suche', 'Social-Media',  'Weiterempfehlung eines zufriedenen Kunden', 'Sonstiges']"
                  v-model="value.abfrageWoherKennstDuUns"
                />
                <v-textarea
                  v-if="value.abfrageWoherKennstDuUns === 'Sonstiges'"
                  label="Sonstige Quelle:"
                  autoGrow
                  v-model="value.abfrageWoherKennstDuUnsSonstiges"
                />
              </div>
              <v-checkbox
                v-model="value.agbUndDatenschutz"
                :label="`Ich habe die AGB und Datenschutzbestimmungen gelesen, zur Kenntnis genommen
                und akzeptiere diese.`"
              />
            </v-form>
            <v-col class="py-0" align="right">
              <v-btn
                text
                @click="
                  e1 = 1;
                "
              >
                Zurück
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="
                  $emit('end', value);
                "
                :disabled="
                  !formvalid2
                  || !value.agbUndDatenschutz
                "
              >
                Anfrage senden
              </v-btn>
            </v-col>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-form>
    <Impressum />
  </v-container>
</template>

<script>
import Impressum from '@/components/Impressum.vue';

export default {
  name: 'BuchungFormFahrtdetails',
  components: {
    Impressum,
  },
  props: {
    prop_value: {
      type: Object,
      default() { return {}; },
    },
    prop_gesamtuebersicht: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default() { return {}; },
    },
  },
  data: () => ({
    e1: null,
    formvalid: true,
    formvalid2: true,
    value: {},
  }),
  watch: {
    value: {
      handler(neu) {
        this.$emit('change', neu);
      },
      deep: true,
    },
  },
  computed: {
  },
  methods: {
  },
  created() {
    this.value = JSON.parse(JSON.stringify(this.prop_value));
  },
};
</script>
